import type { TSportEvent } from 'markets-store'
import { useMarketsStore } from './useMarketsStore'

/**
 * Получение списка всех спортивных событий по вхождунию названия компетитора
 * @example
 * const findEvents = useFindByCompetitorName()
 * findEvents('Барселона')
 */
export function useFindByCompetitorName() {
  const MS = useMarketsStore()
  return (query: string): TSportEvent[] =>
    // @ts-expect-error IndexedActual
    MS.sportEvents?.findByCompetitorName(query) ?? []
}
